import { render } from "./ModalTwoFaReminder.vue?vue&type=template&id=3643b816&scoped=true"
import script from "./ModalTwoFaReminder.vue?vue&type=script&lang=js"
export * from "./ModalTwoFaReminder.vue?vue&type=script&lang=js"

import "./ModalTwoFaReminder.vue?vue&type=style&index=0&id=3643b816&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3643b816"]])

export default __exports__